import React, { useContext, useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import { IoMdSend } from 'react-icons/io'
import { ModalDialog, Button, CustomLinks } from 'components'
import { I18nContext } from 'i18n'
import styled from 'styled-components'

const BluePaperPlane = styled(IoMdSend)`
  color: ${({ theme }) => theme.button.backgroundColor};
  float: right;
  font-size: 3rem;
`

const SendForReviewModal = ({ className, onConfirm, draftCount, ...rest }) => {
  const { translate } = useContext(I18nContext)
  const title = useMemo(() => translate('send_all_for_review_title'), [translate])
  const buttonLabel = useMemo(() => translate('send_all_for_review_button_label'), [translate])

  const subtitle = (
    <div className="px-3 small-font font-weight-lighter mt-1">
      <CustomLinks location="YOUR_PROGRAM_UPDATES.SEND_MY_PROGRAMS" />
    </div>
  )

  return (
    <ModalDialog
      title={title}
      size="lg"
      subtitle={subtitle}
      actionButton={
        <Button primary="true" onClick={onConfirm} className="mr-2">
          {buttonLabel}
        </Button>
      }
      {...rest}
    >
      <h3>
        Ready to send your data to the NSPA team?
        <BluePaperPlane/>
      </h3>
      <Row>
        <Col md={11}>
          {
            draftCount &&
            <article className="mt-4">
              <h6 className="text-primary">A total of {draftCount} scholarships will be sent.</h6>
            </article>
          }
          <article className="mt-4">
            <h6>Overview</h6>
            <p>
              When you send data to the NSPA team, you're letting them know
              about changes to your programs.
            </p>
          </article>
          <article>
            <h6>Things not to worry about</h6>
            <p>
              Don't worry! When you send your changes, they will be reviewed
              by the NSPA team before the data gets posted to the live NSPA
              Exchange site. You can even make additional changes to your data
              up until we start working on the data you sent -- and you can
              always come back and submit more changes.
            </p>
          </article>
          <article>
            <h6>Ready?</h6>
            <p>
              If you're ready to send your data, click Send Data, below.
              Or press Cancel to continue working on your changes.
            </p>
          </article>
        </Col>
      </Row>
    </ModalDialog>
  )
}

export default React.memo(SendForReviewModal)
